import { IOnboardStepProps } from "features/onboarding/types";
import { ApiPlatform } from "@incendium/api";
import OnboardinPixelShopify from "features/onboarding/components/OnboardinPixelShopify";
import { Box } from "@mui/material";
import OnboardingEcwid from "features/onboarding/components/OnboardingEcwid";
import OnboardingWoocmerce from "features/onboarding/components/OnboardingWoocmerce";
import OnboardingGeneral from "features/onboarding/components/OnboardingGeneral";
import OnboardingSPA from "features/onboarding/components/OnboardingSPA";

function OnboardingPixel({ project }: IOnboardStepProps) {
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box sx={{ flex: 1 }}>
        {project.platform === ApiPlatform.PLATFORM_SHOPIFY ? (
          <OnboardinPixelShopify project={project} />
        ) : project.platform === ApiPlatform.PLATFORM_ECWID ? (
          <OnboardingEcwid project={project} />
        ) : project.platform === ApiPlatform.PLATFORM_WOOCOMMERCE ? (
          <OnboardingWoocmerce project={project} isWooCommerce={true} />
        ) : project.platform === ApiPlatform.PLATFORM_WORDPRESS ? (
          <OnboardingWoocmerce project={project} isWooCommerce={false} />
        ) : project.platform === ApiPlatform.PLATFORM_SPA ? (
          <OnboardingSPA project={project} />
        ) : (
          <OnboardingGeneral project={project} />
        )}
      </Box>

    </Box>
  );
}

export default OnboardingPixel;
